<template>
  <generic-trash
    v-model="selected"
    :getPag="getPagAux"
    :getExcel="getExcelAux"
    :getParams="getParamsAux"
    :getParamsMultiple="getParamsMultipleAux"
    :doRestore="doRestoreAux"
    :doDelete="doDeleteAux"
    :FilterPanel="FilterPanel"
    :RouteName="RouteName"
    :dialogTitle="dialogTitle"
    :dialogMesage="dialogMesage"
    :ExcelName="ExcelName"
    :idVista="idVista"
    :HeaderTitle="HeaderTitle"
    :vuexnamespace="vuexnamespace"
    :PayloadSingleId="PayloadSingleId"
    :PayloadMultipleId="PayloadMultipleId"
  />
</template>

<script>
import { i18n } from '@/i18n'
import GenericTrash from '@/views/trash/GenericTrash.vue'
import CustomFilter from '@/components/filters/trash/InvoicesFilter.vue'
import { getInvoices } from '@/services/invoices/getInvoices'
import { getInvoicesExcel } from '@/services/invoices/getInvoicesExcel'
import { deleteTrashInvoice } from '@/services/trash/deleteTrashInvoice'
import { restoreTrashInvoice } from '@/services/trash/restoreTrashInvoice'

export default {
  name: 'vista-papelera-facturas',
  components: {
    GenericTrash,
  },
  data: function () {
    return {
      FilterPanel: CustomFilter,
      RouteName: 'invoicesissued',
      dialogTitle: i18n.t('invoices.delete_invoice'),
      dialogMesage: i18n.t('app.delete_permanent_selected_confirmation_f', { entity: i18n.t('invoices.header').toLowerCase() }),
      ExcelName: 'facturas-emitidas-borradas.xlsx',
      idVista: 42,
      HeaderTitle: i18n.t('trash.invoices_issued'),
      vuexnamespace: 'trashInvoicesIssued',
      PayloadSingleId: ['idFacturae', 'idInvoice'],
      PayloadMultipleId: 'idsFacturas',
      selected: []
    }
  },
  methods: {
    getParamsAux (data) {
      return {
        fechaFacturaDesde: data.fechaFacturaDesde ? data.fechaFacturaDesde.value : null,
        fechaFacturaHasta: data.fechaFacturaHasta ? data.fechaFacturaHasta.value : null,
        fechaTicketBaiHasta: data.fechaTicketBaiHasta ? data.fechaTicketBaiHasta.value : null,
        fechaTicketBaiDesde: data.fechaTicketBaiDesde ? data.fechaTicketBaiDesde.value : null,
        tipoInvoiceClass: data.tipoInvoiceClass ? data.tipoInvoiceClass.value : null,
        pge: data.pge ? data.pge.value : null,
        importeMinimo: data.importeDesde ? data.importeDesde.value : null,
        importeMaximo: data.importeHasta ? data.importeHasta.value : null,
        numFactura: data.numFactura ? data.numFactura.value : null,
        SerieFactura: data.SerieFactura ? data.SerieFactura.value : null,
        cifEmisor: data.cifEmisor ? data.cifEmisor.value : null,
        nombreCIFEmisor: data.NombreCIFEmisor ? data.NombreCIFEmisor.value : null,
        cifReceptor: data.cifReceptor ? data.cifReceptor.value : null,
        CodCliente: data.CodCliente ? data.CodCliente.value : null,
        nombreCIFReceptor: data.NombreCIFReceptor ? data.NombreCIFReceptor.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value.idCliente : null,
        comentarios: data.notas ? data.notas.value : null,
        importe: data.importe ? data.importe.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
        ultimoError: data.ultimoError ? data.ultimoError.value : null,
        MotivoRechazo: data.motivoRechazo ? data.motivoRechazo.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        fechaPagoDesde: data.fechaPagoDesde ? data.fechaPagoDesde.value : null,
        fechaPagoHasta: data.fechaPagoHasta ? data.fechaPagoHasta.value : null,
        fechaRechazoDesde: data.fechaRechazoDesde ? data.fechaRechazoDesde.value : null,
        fechaRechazoHasta: data.fechaRechazoHasta ? data.fechaRechazoHasta.value : null,
        csv: data.csv ? data.csv.value : null,
        recibidas: false,
        borradas: true,
        contieneAdjuntos: data.contieneAdjuntos ? data.contieneAdjuntos.value : null,
        estadoTicketbai: data.estadoTicketbai ? data.estadoTicketbai.value : null,
        IdTBAI: data.IdTBAI ? data.IdTBAI.value : null,
        agrupacionCIF: data.agrupacionCIF ? data.agrupacionCIF.value : null,
        OrigenFactura: data.OrigenFactura ? data.OrigenFactura.value : null,
        estadoRecurrencia: data.EstadoRecurrencia ? data.EstadoRecurrencia.value : null,
        idFacturaRecurrente: data.IdFacturaRecurrente ? data.IdFacturaRecurrente.value.idRecurrencia : null,
        fechaVencimientoDesde: data.fechaVencimientoDesde ? data.fechaVencimientoDesde.value : null,
        fechaVencimientoHasta: data.fechaVencimientoHasta ? data.fechaVencimientoHasta.value : null,
        SEPAGenerado: data.SEPAGenerado ? data.SEPAGenerado.value : null,
      }
    },
    getParamsMultipleAux: function (data) {
      const params = {}
      if (data.estadoExtraRecibidas?.value?.length) {
        params.estadosFacturas = data.estadoExtraRecibidas.value 
      }
      if (data.metadatos?.value?.length) {
        params.metadatos = data.metadatos.value
      }
      return params
    },
    getPagAux: async function (objOrder, params) {
      return await getInvoices(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      return await getInvoicesExcel(objOrder, params)
    },
    doRestoreAux: async function (payload) {
      return await restoreTrashInvoice(payload)
    },
    doDeleteAux: async function (payload) {
      return await deleteTrashInvoice(payload)
    },
  }
}
</script>
